<template>
  <div class="wizard-steps">
    <div v-for="i in total" :key="i" class="step" :class="stepClass(i)"></div>
  </div>
</template>
<script>
export default {
  name: "WizardSteps",
  props: {
    total: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 0,
    },
    styleType: {
      type: String,
      default: 'style1',
    },
  },
  methods: {
    stepClass(i) {
      return {
        active: i === this.step,
        style1: this.styleType === 'style1',
        style2: this.styleType === 'style2',
        style3: this.styleType === 'style3',
      };
    },
  },
};
</script>
<style scoped>
.wizard-steps {
  display: flex;
  justify-content: center;
  align-items: center;
}

.step {
  width: 8px;
  height: 8px;
  margin-right: 18px;
  border-radius: 50%;
  opacity: 0.7;
}

.step.style1 {
  background: rgb(214, 205, 189);
}
.step.style1.active {
  background: rgb(0, 0, 0);
}

.step.style2 {
  background: rgb(89, 167, 224);
}
.step.style3 {
  background: rgb(0, 0, 0);
}


.step.active {
  width: 16px;
  height: 16px;
  opacity: 1;
}
</style>
